<!--
  @component
  Generates HTML text labels for a nested data structure. It places the label near the y-value of the highest x-valued data point. This is useful for labeling the final point in a multi-series line chart, for example. It expects your data to be an array of objects where each has `values` field that is an array of data objects. It uses the `z` field accessor to pull the text label.
 -->
<script>
	import { getContext, onMount } from "svelte";
	import { max } from "d3-array";
	import { draw, fade } from "svelte/transition";
	import { quintOut } from "svelte/easing";
	import arrow from "../../icons/arrow.svg";
	import participantsIcon from "../../icons/participants.svg";

	const { data, yGet, zGet, xGet, xScale, yScale, xDomain, yDomain } = getContext("LayerCake");

	export let lineDrawDuration;
 export let value;
 export let label;
 export let dateLabel;
 export let labelOffset = 50;
 export let animationDelay;
 export let valueLabel
 export let date;

 // export let renderedLines
 export let id;

 // onMount(() => {
 //  console.log('mounting', renderedLines, renderedLines[id])
  
 // })
		
	// $: delay = !renderedLines[id] ? 1000 : 0

	// $: console.log(id, delay)
</script>

<div
 class="Annotation__label-container"
 in:fade={{ duration: 300, ease: quintOut }}
 style:left={`${$xScale(date)}px`}
 style:top={`${$yScale(value)}px`}
>
 <div class="Annotation__label" style:transform={`translate(${-labelOffset}px, ${-labelOffset}px)`}>
  <span class="Annotation__label__secondary">{dateLabel}</span>
  <div class="Annotation__label__main">
   {#each label.split('<br>') as textLine}
    <span>{textLine}</span>
   {/each}
  </div>
  {#if valueLabel}
   <div class="with-icon">
    <span class="Annotation__label__secondary">{valueLabel}</span>
    <img src={participantsIcon} />
   </div>
  {/if}
 </div>
</div>
<div
 class="Annotation__arrow-container"
 in:fade={{ duration: 300, ease: quintOut }}
 style:left={`${$xScale(date)}px`}
 style:top={`${$yScale(value)}px`}
>
 <img class="Annotation__arrow" src={arrow} style:width={`${labelOffset}px`} style:height={`${labelOffset}px`}/>
</div>
	
<style lang="scss">
	$labelOffsetMobile: 0;

	.Annotation {
		&__label-container,
		&__arrow-container {
			position: absolute;
		}

		&__arrow-container {
			transform: translate(-100%, -100%);
		}

		&__label-container {
			transform: translate(-100%, -50%);
		}

		&__label {
			// box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
			padding: 5px;
			// transform: translate(-$labelOffset, -$labelOffset);

			@media (max-width: $breakpoint-mobile-l) {
				transform: translate(-$labelOffsetMobile, -$labelOffsetMobile) !important;
			}

			&__secondary,
			&__main {
				display: block;
				text-align: left;
				text-shadow: 0px 0px 10px #211c46;
				font-size: 11px;
				font-style: normal;
				font-weight: 400;
				line-height: 115%;
				// white-space: nowrap;
				// border: 2px solid #211C46;
			}

			&__secondary {
				color: #838aa4;
				line-height: 1.8;
				white-space: nowrap;
			}

			&__main {
				font-weight: $bold;
				color: #bbc9d9;

				span {
					display: block;
					white-space: nowrap;
				}
			}
		}

		&__arrow {
			transform: rotate(0deg) scaleX(-1);

			@media (max-width: $breakpoint-mobile-l) {
				width: 0 !important;
				height: 0 !important;
			}
		}
	}

	.with-icon {
		display: inline-flex;
		align-items: center;

		img {
			height: 14px;
			transform: translateY(-2px);
		}
	}
</style>
